module.exports = __webpack_public_path__ + "img/sign-in.572fd41f.svg";